import { Component, OnInit } from '@angular/core';
import {LetterTemplateDataModel} from '../../models/letters/letter-template-data.model';
import {LettersService} from '../../services/letters.service';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {NotificationNeededDataModel} from '../../models/messaging/noteToFront/notification-needed-data.model';
import {NotificationNeededItemDataModel} from '../../models/messaging/noteToFront/notification-needed-item-data.model';
import {LettersRecipientsDialogComponent} from '../letters-recipients-dialog/letters-recipients-dialog.component';
import {LettersDeliveryOptionsDialogComponent} from '../letters-delivery-options-dialog/letters-delivery-options-dialog.component';
import {ContactDataModel} from '../../models/person/contact-data.model';
import {DoctorsService} from '../../services/doctors.service';
import {Globals} from '../../globals';
import {ClientLocationDataModel} from '../../models/clients/client-location-data.model';

@Component({
  standalone: false,
  selector: 'app-letters-selection-dialog',
  templateUrl: './letters-selection-dialog.component.html',
  styleUrls: ['./letters-selection-dialog.component.scss']
})
export class LettersSelectionDialogComponent implements OnInit {
  templates: LetterTemplateDataModel[] = [];
  selectedTemplate: LetterTemplateDataModel;
  dummyNeededItem: NotificationNeededItemDataModel = new NotificationNeededItemDataModel();

  neededItems: NotificationNeededItemDataModel[] = [];
  locations: ClientLocationDataModel[] = [];
  selectedContacts: ContactDataModel[] = [];
  toNames: string = '';
  ccNames: string = '';
  bccNames: string = '';

  constructor(private lettersService: LettersService,
              private dialog: MatDialog,
              private dialogRef: MatDialogRef<LettersSelectionDialogComponent>,
              private doctorsService: DoctorsService,
              private globals: Globals) { }

  ngOnInit(): void {
    this.lettersService.getTemplates().subscribe((res) => {
      this.templates = res;
    });
    this.dummyNeededItem.enumLetterDeliveryMethodID = '00000251-1000-0000-0000-000000000001';
    // Load the client's locations so the delivery-options dialog can offer a
    // send-time "Letters Email From:" override (TX-7010).
    this.doctorsService.getClientLocations(this.globals.TDOCID).subscribe((res) => {
      this.locations = res ?? [];
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    // Return selected / inputted information
    this.dialogRef.close({neededItems: this.neededItems, selectedContacts: this.selectedContacts, template: this.selectedTemplate});
  }

  onTemplateClick(template: LetterTemplateDataModel) {
    this.selectedTemplate = template;
    this.dummyNeededItem.ObjectID = template.LetterTamplateID;
    this.dummyNeededItem.Description = template.LetterName;

    if (this.neededItems) {
      for (const item of this.neededItems) {
        item.ObjectID = this.dummyNeededItem.ObjectID;
        item.Description = this.dummyNeededItem.Description;
      }
    }
  }

  onDeliveryTypeClick(s: string) {
    this.dummyNeededItem.enumLetterDeliveryMethodID = s;
  }

  onEditList() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(LettersRecipientsDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        if (res.selectedContacts) {
          this.selectedContacts = res.selectedContacts;
        }
        if (res.neededItems) {
          this.neededItems = res.neededItems;
          for (const item of this.neededItems) {
            item.ObjectID = this.dummyNeededItem.ObjectID;
            item.Description = this.dummyNeededItem.Description;
            item.Subject = this.dummyNeededItem.Subject;

            const contact = this.selectedContacts.find(p => p.ContactId === item.ToContactID);
            if (contact) {
              if (this.toNames.length === 0) {
                this.toNames += contact.FirstName + ' ' + contact.LastName;
              } else {
                this.toNames += '; ' + contact.FirstName + ' ' + contact.LastName;
              }
            }
          }
        }
      }
    });
  }

  onClearList() {
    //
  }

  onOptionsClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = { locations: this.locations, currentLocationId: this.globals.LOCID };
    this.dialog.open(LettersDeliveryOptionsDialogComponent, config).afterClosed().subscribe((res) => {
      // `res` is the chosen source LocationID on OK (may be '' for no override),
      // or undefined on Cancel.
      if (res !== undefined && res !== null) {
        this.setEmailFromLocation(res);
      }
    });
  }

  private setEmailFromLocation(locationId: string) {
    this.dummyNeededItem.EmailFromLocationID = locationId;
    for (const item of this.neededItems) {
      item.EmailFromLocationID = locationId;
    }
  }

  isOkDisabled() {
    if (this.dummyNeededItem.ObjectID && this.neededItems.length !== 0) {
      return false;
    }

    return true;
  }

  onSubjectInput(event: any) {
    this.dummyNeededItem.Subject = event;
    for (const item of this.neededItems) {
      item.Subject = event;
    }
  }
}
